import { render } from "./TransportCostIndex.vue?vue&type=template&id=29665e36&ts=true"
import script from "./TransportCostIndex.vue?vue&type=script&lang=ts"
export * from "./TransportCostIndex.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\y-sakakibara\\Documents\\Git\\workflow-system\\workflow\\frontend\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__